import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { alarmError } from 'src/app/classes/device';
import { ToastrService } from 'ngx-toastr';
import { Subscription, interval, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { MatInput } from '@angular/material';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

@Component({
  selector: 'app-alarms',
  templateUrl: './alarms.component.html',
  styleUrls: ['./alarms.component.scss']
})
export class AlarmsComponent implements OnInit {

  @ViewChild('input', { read: MatInput, static: false }) input: MatInput
  @ViewChild('input1', { read: MatInput, static: false }) input1: MatInput
  @ViewChild('input2', { read: MatInput, static: false }) input2: MatInput
  @ViewChild('input3', { read: MatInput, static: false }) input3: MatInput

  private ResponseVerifiedGetAllNormalUser$: Subject<any> = new Subject();
  private ResponseVerifiedUnclearAlarms$: Subject<any> = new Subject();
  private ResponseVerifiedClearAlarms$: Subject<any> = new Subject();


  alarmError = new alarmError();
  role: any;
  jobj: any;
  public selected;
  offsetClearAlarms = 0;
  limit = 10;
  roleName: string;
  alarmForm: FormGroup;
  alarmFormClear: FormGroup;
  clearedAlarms: any = [];
  clearedAlarmsCSV: any = [];
  unClearedAlarms: any = [];
  unClearedCSVAlarms: any = [];
  epcId: any;
  page = 1;
  page1 = 1;
  alarmObj: {};
  listOfNormalAndWmsUser: any;
  private updateSubscription: Subscription;
  pipe = new DatePipe('en-US');
  unclearStartDate: string;
  unclearEndDate: string;
  clearEndDate: string;
  clearStartDate: string;
  count: number;
  offsetUnClearAlarms = 0;
  unClearedAlarmsCount: number;
  AlarmsTab: any;
  formula: string = "Download_CSV";
  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private dashbord: DashboardService, private toastr: ToastrService) {
    this.role = localStorage.role;
    this.epcId = localStorage.id;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '3') {
      this.roleName = 'wms';
    } else if (this.role == '4') {
      this.roleName = 'normal';
    }
  }

  ngOnInit() {
    this.alarmForm = this.fb.group({
      user_id: ['', Validators.required],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
    }
    );
    this.alarmFormClear = this.fb.group({
      user_id: ['', Validators.required],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
    }
    );
    if (this.role == '2') {
      this.AlarmsTab = 'UnClearedAlarmsTab';
      this.getUnclearedAlarms(0);
      this.getEpcNormalUser();
      // this.updateSubscription = interval(300000).subscribe(
      //   () => {
      //     this.getUnclearedAlarms(0);

      //     this.getEpcNormalUser();
      //   });
    } else if (this.role == '1') {
      // this.updateSubscription = interval(300000).subscribe(
      //   () => {

      //   });
    } else if (this.role == '3') {
      // this.updateSubscription = interval(300000).subscribe(

      //   () => {
      //   });
    } else if (this.role == '4') {
      // this.updateSubscription = interval(300000).subscribe(
      //   () => {
      //   });
    }
  }


  get f() { return this.alarmForm.controls; }

  // cleared alarms Tab
  showClearedAlarmsTab(Tab) {
    this.AlarmsTab = Tab;
    this.offsetClearAlarms =0;
    this.getClearedAlarms(this.offsetClearAlarms);
    // this.getClearedAlarms(0);
    this.resetUnClearedAlarams();
  }
  // cleared alarms Tab
  showUnClearedAlarmsTab(Tab) {
    this.AlarmsTab = Tab;
    this.offsetUnClearAlarms=0;
    this.getUnclearedAlarms(this.offsetUnClearAlarms);
    // this.getUnclearedAlarms(0);
    this.resetClearedAlarams()
  }
  // getAll Epc NormlUser
  getEpcNormalUser() {
    this.dashbord.getEpcNormalUser()
      .pipe(takeUntil(this.ResponseVerifiedGetAllNormalUser$))
      .subscribe(
        async data => {
          if (data.status) {
            this.listOfNormalAndWmsUser = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // for Epc User

  getUnclearedAlarms(offset) {
    // nevigate first page
    if (offset == 0) {
      this.page1 = 1
    }
    this.unclearStartDate = this.pipe.transform(this.alarmForm.controls['to_date'].value, "yyyy-MM-dd");
    this.unclearEndDate = this.pipe.transform(this.alarmForm.controls['from_date'].value, "yyyy-MM-dd");
    this.alarmObj = {
      epc_id: this.epcId,
      user_id: this.alarmForm.controls['user_id'].value,
      start_date: this.unclearStartDate,
      end_date: this.unclearEndDate,
      limit: this.limit,
      offset: offset
    }
    this.dashbord.getUnclearedAlarms(this.alarmObj)
      .pipe(takeUntil(this.ResponseVerifiedUnclearAlarms$))
      .subscribe(
        async data => {
          this.unClearedAlarmsCount = 0;
          this.unClearedAlarms = [];
          if (data.status == true || data.status == 'true') {
            this.unClearedAlarmsCount = data.count
            this.unClearedAlarms = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  // reset value ClearedAlarams For Epc User
  public resetClearedAlarams() {
    // this.input2.value = '';
    // this.input3.value = '';
    this.alarmFormClear.controls.to_date.setValue('');
    this.alarmFormClear.controls.from_date.setValue('');
    this.alarmFormClear.reset();
    this.offsetClearAlarms =0;
    this.getClearedAlarms(this.offsetClearAlarms);
    // this.getClearedAlarms(0);
  }
  // reset value ClearedAlarams For Epc User
  public resetUnClearedAlarams() {
    // this.input.value = '';
    // this.input1.value = '';
    this.alarmForm.controls.to_date.setValue('');
    this.alarmForm.controls.from_date.setValue('');
    this.alarmForm.reset();
    this.offsetUnClearAlarms=0;
    this.getUnclearedAlarms(this.offsetUnClearAlarms);
    // this.getUnclearedAlarms(0);
  }
  // get clearedAlarms
  getClearedAlarms(offset) {
    // nevigate first page
    if (offset == 0) {
      this.page = 1
    }
    this.clearStartDate = this.pipe.transform(this.alarmFormClear.controls['to_date'].value, "yyyy-MM-dd");
    this.clearEndDate = this.pipe.transform(this.alarmFormClear.controls['from_date'].value, "yyyy-MM-dd");
    this.alarmObj = {
      epc_id: this.epcId,
      user_id: this.alarmFormClear.controls['user_id'].value,
      start_date: this.clearStartDate,
      end_date: this.clearEndDate,
      limit: this.limit,
      offset: this.offsetClearAlarms
    }
    this.dashbord.getClearedAlarms(this.alarmObj)
      .pipe(takeUntil(this.ResponseVerifiedClearAlarms$))
      .subscribe(
        async data => {
          this.count = 0;
          this.clearedAlarms = [];
          if (data.status) {
            this.count = data.count
            this.clearedAlarms = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  nextPageClearAlarms(pageIndex): void {
    this.offsetClearAlarms = (pageIndex - 1) * 10;
    // this.page = pageIndex;
    this.getClearedAlarms(this.offsetClearAlarms);
  }

  nextPageUncleredAlarams(pageIndex): void {
    this.offsetUnClearAlarms = (pageIndex - 1) * 10;
    // this.page = pageIndex;
    this.getUnclearedAlarms(this.offsetUnClearAlarms);
  }

  // download csv for cleared alarm
  downloadClearedAlaramsCSV() {
    this.clearStartDate = this.pipe.transform(this.alarmFormClear.controls['to_date'].value, "yyyy-MM-dd");
    this.clearEndDate = this.pipe.transform(this.alarmFormClear.controls['from_date'].value, "yyyy-MM-dd");
    this.alarmObj = {
      epc_id: this.epcId,
      user_id: this.alarmFormClear.controls['user_id'].value,
      start_date: this.clearStartDate,
      end_date: this.clearEndDate,
      limit: '0',
      offset: '0'
    }
    this.dashbord.getClearedAlarms(this.alarmObj)
      .pipe(takeUntil(this.ResponseVerifiedClearAlarms$))
      .subscribe(
        async data => {
          if (data.status) {
            this.count = data.count
            this.clearedAlarmsCSV = data.resultObject;
            var data = this.clearedAlarmsCSV;
            var options = {
              title: 'Cleared Alarms',
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalseparator: '.',
              showLabels: true,
              showTitle: true,
              useBom: true,
              headers: ['Login Id', 'Device Name', ' Name', 'Inverter Name', 'Alarm Id', 'Occurance Time', 'Clearance Time ', 'Alarm Message']
            };
            new Angular5Csv(data, this.formula, options);
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  //download csv fo uncleared alarm
  csvDownloadUnClearedAlarams() {
    this.unclearStartDate = this.pipe.transform(this.alarmForm.controls['to_date'].value, "yyyy-MM-dd");
    this.unclearEndDate = this.pipe.transform(this.alarmForm.controls['from_date'].value, "yyyy-MM-dd");
    this.alarmObj = {
      epc_id: this.epcId,
      user_id: this.alarmForm.controls['user_id'].value,
      start_date: this.unclearStartDate,
      end_date: this.unclearEndDate,
      limit: '0',
      offset: '0'
    }
    this.dashbord.getUnclearedAlarms(this.alarmObj)
      .pipe(takeUntil(this.ResponseVerifiedUnclearAlarms$))
      .subscribe(
        async data => {
          this.unClearedAlarmsCount = 0;
          this.unClearedCSVAlarms = [];
          if (data.status == true || data.status == 'true') {
            this.unClearedCSVAlarms = data.resultObject;
            var data = this.unClearedCSVAlarms;
            var options = {
              title: 'Un-Cleared Alarms',
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalseparator: '.',
              showLabels: true,
              showTitle: true,
              useBom: true,
              headers: ['login_id', 'Device Name', 'Name', 'Inverter Name', 'Alarm Id', 'Occurance Time', 'Alarm Message']
            };
            new Angular5Csv(data, this.formula, options);
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );

  }
  ngOnDestroy() {
    // this.updateSubscription.unsubscribe();

    this.ResponseVerifiedGetAllNormalUser$.next();
    this.ResponseVerifiedGetAllNormalUser$.complete();

    this.ResponseVerifiedUnclearAlarms$.next();
    this.ResponseVerifiedUnclearAlarms$.complete();

    this.ResponseVerifiedClearAlarms$.next();
    this.ResponseVerifiedClearAlarms$.complete();
  }

}
